<template>
  <Base icon="mdi-book-open-variant" :satisfied="requirement.satisfied" tooltip>
    <span>
      Study rights
    </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }}
      {{ requirement.negative ? 'not' : '' }}
      have study rights in {{ requirement.country.name }}
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
}
</script>
